import '@fontsource-variable/alexandria';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary';
import { ThemeProvider } from '@/theme/ThemeProvider';
import App from './App';
import './index.css';
import { SnackbarProvider } from 'notistack';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: false,
    },
  },
});

// Get the root element
const rootElement = document.getElementById('root');

// Ensure the root element exists before creating the root
if (!rootElement) {
  throw new Error('Root element with ID "root" not found in the document.');
}

// Create the root
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <LocalizationProvider dateAdapter={AdapterLuxon}>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider>
              <BrowserRouter>
                <ScrollToTop />
                <SnackbarProvider
                  dense
                  preventDuplicate
                  anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
                  autoHideDuration={1500}
                  maxSnack={3}
                >
                  <App />
                </SnackbarProvider>
              </BrowserRouter>
            </ThemeProvider>
          </QueryClientProvider>
        </LocalizationProvider>
      </ErrorBoundary>
    </HelmetProvider>
  </StrictMode>,
);
